/**
 * Склонение для русского: формы через запятую «1,2,5» (например «экскурсия,экскурсии,экскурсий»).
 */
export const pluralizeRu = (n: number, forms: string): string => {
  const [one = '', few = '', many = ''] = forms.split(',');
  const mod10 = n % 10;
  const mod100 = n % 100;

  if (mod100 >= 11 && mod100 <= 14) {
    return many;
  }

  if (mod10 === 1) {
    return one;
  }

  if (mod10 >= 2 && mod10 <= 4) {
    return few;
  }

  return many;
};
